const Theme = {
  token: {
    borderRadius: 4,
    colorPrimary: 'rgba(0, 69, 165, 0.3)',
  },
};

export { Theme };
